import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=3615824e&"
import script from "./CreateNews.vue?vue&type=script&lang=js&"
export * from "./CreateNews.vue?vue&type=script&lang=js&"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=3615824e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports